import { useCallback } from 'react'
import { toast } from 'sonner'
import { LabelPrinterPopoverControl } from '@/components/label-printer-popover'
import type { useLabelPrinter } from '@/context/label-printer'
import { cn } from '@/lib/utils'

type LabelPrinterToolbarProps = {
  className?: string
  state: ReturnType<typeof useLabelPrinter>
}

export function LabelPrinterToolbar(props: LabelPrinterToolbarProps) {
  const { className, state } = props
  const {
    strategy,
    strategyLabel,
    printers,
    selectedPrinter,
    loadingPrinters,
    error,
    refreshPrinters,
    selectPrinter,
    setStrategy,
    testPrint,
    jobs,
  } = state

  const handleTestPrint = useCallback(async () => {
    try {
      await testPrint()
      toast.success('Test label sent')
    } catch (error) {
      const actual = error instanceof Error ? error : new Error('Unable to run test print')
      toast.error(actual.message)
      throw actual
    }
  }, [testPrint])

  return (
    <div
      className={cn(
        'transition-opacity',
        strategy === 'dymo' && !selectedPrinter && 'opacity-80',
        className
      )}
    >
      <LabelPrinterPopoverControl
        strategy={strategy}
        strategyLabel={strategyLabel}
        printers={printers}
        selectedPrinter={selectedPrinter}
        loadingPrinters={loadingPrinters}
        error={error}
        onRefresh={refreshPrinters}
        onSelectPrinter={selectPrinter}
        onSetStrategy={setStrategy}
        onTestPrint={handleTestPrint}
        jobs={jobs}
      />
    </div>
  )
}

export default LabelPrinterToolbar
